if (typeof RelatedCollections != 'function') {
	class RelatedCollections extends HTMLElement {
		constructor() {
			super();

			this.uniqueClass = `.splide--${this.dataset.id}`;
			this.slider = this.querySelector('.splide');
			this.slides = this.slider.querySelectorAll('.splide__slide');
			this.showArrows = /true/.test(this.dataset.showArrows);
			this.numberOfCollections = this.dataset.numberOfCollections;
			this.splideType = this.dataset.splideType || 'slide';

			if (window.Shopify.designMode) {
				document.addEventListener('shopify:section:load', () => {
					this.init();
				});
			}
		}

		connectedCallback() {
			this.init();
		}

		init() {
			new Splide(this.uniqueClass, {
				type: this.splideType,
				gap: '20px',
				perMove: Math.min(6, this.numberOfCollections),
				perPage: Math.min(6, this.numberOfCollections),
				arrows: this.showArrows,
				pagination: this.showArrows,
				breakpoints: {
					1024: {
						perPage: Math.min(4, this.numberOfCollections),
						perPage: Math.min(4, this.numberOfCollections),
					},
					768: {
						perPage: Math.min(3, this.numberOfCollections),
						perPage: Math.min(3, this.numberOfCollections),
					},
					640: {
						perPage: Math.min(2, this.numberOfCollections),
						perPage: Math.min(2, this.numberOfCollections),
					},
				},
			}).mount();
		}
	}
	if (!customElements.get('related-collections')) {
		customElements.define('related-collections', RelatedCollections);
	}
}
